import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  public frontOfficeURL: string;

  constructor(private router: Router) {
    this.frontOfficeURL = environment.frontOfficeURL;
  }

  /**
   * Calculates the current year.
   * @returns {string} The current year in string format.
   */
  public getCurrentYear(): string {
    return new Date().getFullYear().toString();
  }
}
